export function setUser(user) {
  console.log("user", user);
  localStorage.setItem("user", JSON.stringify(user));
}

export function getUser() {
  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString);
  // console.log('user',user);
  return user;
}

export function removeUser() {
  localStorage.removeItem("user");
}
